import React from 'react'

const Privarypolicy = () => {
  return (
   <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px", lineHeight: "1.7" }}>
      <h1>Privacy Policy</h1>
      <p>Last Updated: 09/12/2025</p>

      <p>
        Aamantran ("we", "our", "us") operates aamantran.link. 
        This Privacy Policy explains how we collect, use, and protect your information 
        when you use our digital wedding invite platform.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Name, email, phone/WhatsApp number</li>
        <li>Wedding/event details such as names, dates, venue, photos, messages</li>
        <li>Login information</li>
        <li>Payment details (processed by Razorpay)</li>
        <li>Technical data like IP address, browser type, usage logs</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Create and maintain your wedding invite</li>
        <li>Provide customer support</li>
        <li>Improve and customize the platform</li>
        <li>Process payments securely through Razorpay</li>
        <li>Send updates through WhatsApp/email</li>
      </ul>

      <h2>3. Data Security</h2>
      <p>
        We use HTTPS, encryption, and secure servers. 
        Payment information is handled securely by Razorpay and never stored by us.
      </p>

      <h2>4. Sharing of Information</h2>
      <p>We may share data only with:</p>
      <ul>
        <li>Razorpay (for payment processing)</li>
        <li>Hosting & infrastructure providers</li>
        <li>Analytics/service partners</li>
      </ul>

      <h2>5. Cookies</h2>
      <p>We use cookies for login sessions and analytics.</p>

      <h2>6. User Rights</h2>
      <p>You may request deletion or correction of your data by emailing us at:</p>
      <p><strong>support@aamantraninvites.com</strong></p>

      <h2>7. Changes to Policy</h2>
      <p>This page will always contain the latest updated privacy policy.</p>
    </div>
  )
}

export default Privarypolicy